import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { ApiProvider } from '../api/api';

@Injectable()
export class MasterGuardService implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router,
    private api: ApiProvider,
  ) {}

  canActivate(): Promise<boolean> | boolean {
    if (!this.auth.isLoggednIn() || this.auth.getAccountType() !== 'master') {
      this.router.navigate(['login'], { skipLocationChange: true });
      return false;
    }

    return this.api.get('master/v2/access').then(
      () => true,
      () => {
        this.router.navigate(['login'], { skipLocationChange: true });
        return false;
      }
    );
  }
}
